import { __awaiter } from "tslib";
import React from 'react';
import classNames from 'classnames';
/** app */
import { initApp } from '../application-module';
import { XFlowAppInternalProvider, useXFlowApp } from './app-context';
/** app-extension */
import { ExtensionRegistryContext } from './extension-context';
import { useXflowPrefixCls } from './global-config-context';
import { XFlowAppExtensionModule } from './app-extension-module';
import { ExtensionRegistry, createExtensionRegistry } from './extension-registry';
/** graph */
import { XFlowCanvas } from './canvas';
/** command */
import { ModelServiceRegistry } from '../../model-service';
import { CommandsRegistry, XFlowGraphCommands } from '../../command-contributions';
/** hook */
import { HookRegistry } from '../../hooks';
/** UI model */
import { ToolbarRegistry } from '../../toolbar';
import { MenuRegistry } from '../../menu';
export const XFlow = props => {
    const { meta, graphConfig, graphData, graphLayout, onLoad, isAutoCenter, hookConfig, modelServiceConfig, commandConfig, onAppConfigReady, onAppDestroy, children = [], className, style, } = props;
    const [appRef, setAppRef] = React.useState();
    /** 所有组件父容器 */
    const appContainerRef = React.useRef(null);
    /** XFlow App 配置中心 */
    const extensionRegistry = createExtensionRegistry();
    /** didMount */
    React.useEffect(() => {
        /** before app start */
        if (onAppConfigReady) {
            onAppConfigReady(extensionRegistry);
        }
        /** 初始化应用 */
        const app = initApp(extensionRegistry);
        app.start().then(() => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            /** 保留引用 */
            setAppRef(app);
            (_a = extensionRegistry.getExtension('GraphConfig')) === null || _a === void 0 ? void 0 : _a.config.setAppContainer(appContainerRef.current);
            /** 自动执行 load Meta */
            if (meta) {
                yield app.commandService.executeCommand(XFlowGraphCommands.LOAD_META.id, { meta });
            }
            /** after app start */
            if (onLoad) {
                onLoad(app, extensionRegistry);
            }
            if (graphData) {
                if (graphLayout) {
                    yield app.commandService.executeCommand(XFlowGraphCommands.GRAPH_LAYOUT.id, Object.assign({ graphData }, graphLayout));
                }
                yield app.commandService.executeCommand(XFlowGraphCommands.GRAPH_RENDER.id, { graphData });
            }
        }));
        /** unmount */
        const destroy = () => __awaiter(void 0, void 0, void 0, function* () {
            onAppDestroy && onAppDestroy(app);
        });
        return () => {
            destroy();
        };
        /** 不要删 保证只生成一次 */
        // eslint-disable-next-line
    }, []);
    /** 自动更新meta */
    React.useEffect(() => {
        if (appRef) {
            appRef.commandService.executeCommand(XFlowGraphCommands.LOAD_META.id, { meta });
        }
        /** 不要删 只和meta联动 */
        // eslint-disable-next-line
    }, [meta]);
    /** 自动渲染画布内容 */
    React.useEffect(() => {
        const fn = () => __awaiter(void 0, void 0, void 0, function* () {
            if (appRef) {
                if (graphData && graphLayout) {
                    yield appRef.commandService.executeCommand(XFlowGraphCommands.GRAPH_LAYOUT.id, Object.assign({ graphData }, graphLayout));
                }
                yield appRef.commandService.executeCommand(XFlowGraphCommands.GRAPH_RENDER.id, {
                    graphData,
                });
                /** 自动居中画布内容 */
                if (isAutoCenter) {
                    const x6Graph = yield appRef.getGraphInstance();
                    x6Graph.centerContent();
                }
            }
        });
        fn();
        /** 不要删 只和graphData联动 */
        // eslint-disable-next-line
    }, [graphData]);
    /** classname */
    const appClzName = classNames('xflow-app-workspace', className, ...extensionRegistry.getContainerClassNames());
    /** 判断是否需要自动渲染画布组件, 坐标相对于xflow-graph-root */
    const hasCanvasComponent = (Array.isArray(children) ? children : [children]).some(child => {
        return child && child.props.isXFlowCanvas;
    });
    return (React.createElement(XFlowAppInternalProvider, { app: appRef },
        React.createElement(ExtensionRegistryContext.Provider, { value: extensionRegistry },
            React.createElement("div", { className: appClzName, id: extensionRegistry.getInstanceId(), ref: appContainerRef, style: style },
                !hasCanvasComponent && (React.createElement(XFlowCanvas, { config: graphConfig, position: { top: 0, bottom: 0, left: 0, right: 0 } })),
                children,
                React.createElement(ModelServiceRegistry, { config: modelServiceConfig }),
                React.createElement(CommandsRegistry, { config: commandConfig }),
                React.createElement(HookRegistry, { config: hookConfig }),
                React.createElement(ToolbarRegistry, null),
                React.createElement(MenuRegistry, null)))));
};
XFlow.defaultProps = {};
export default XFlow;
export { useXFlowApp, useXflowPrefixCls, XFlowCanvas, XFlowAppExtensionModule as XFlowAppExtension, ExtensionRegistry, };
//# sourceMappingURL=index.js.map